<section class="additional-properties">
  <div>
    <h4>Additional properties</h4>
    <p class="help-text">Object: {{ objectType() === 'leads' ? 'Lead' : 'Contact' }} @if (context) { · HubSpot portal {{ context.portalId }} }</p>
  </div>
  <mat-form-field appearance="outline" class="action-picker">
    <mat-label>Action</mat-label>
    <mat-select [value]="selectedAction" (selectionChange)="selectAction($event.value)" [disabled]="disabled">
      @for (action of actions; track action) {<mat-option [value]="action">{{ labels[action] }}</mat-option>}
    </mat-select>
  </mat-form-field>
  <p class="help-text">
    @if (selectedAction === 'contactCreate') { Fill missing values when a poll creates a new contact. Existing contacts are kept as they are. }
    @else if (selectedAction === 'leadCreate') { Fill missing values when a poll creates a lead. Contact properties are configured separately. }
    @else { Supply contact properties when registration or attendance creates a new contact through Marketing Events. Existing contacts are kept as they are. }
    Values already supplied by Shine take priority.
  </p>
  @if (connectionChanged) {
    <div class="connection-notice" role="alert">
      <p>The HubSpot connection has changed. Review all actions before saving for this connection.</p>
      <button mat-stroked-button type="button" (click)="useCurrentConnection()" [disabled]="disabled || !context || !!loading[objectType()]">Use current connection</button>
    </div>
  }
  @if (loading[objectType()]) {<p class="help-text" role="status">Loading HubSpot properties…</p>}
  @if (errors[objectType()]) {
    <p class="property-error" role="alert">Properties could not be loaded for this object. Check the HubSpot connection and access.</p>
    <button mat-stroked-button type="button" (click)="loadContext()" [disabled]="disabled">Retry</button>
  }
  <div class="property-rows">
    @for (row of rows().controls; track row; let index = $index) {
      <div class="property-row" [formGroup]="row">
        <mat-form-field appearance="outline">
          <mat-label>HubSpot property name</mat-label>
          <input matInput formControlName="propertyName" [matAutocomplete]="propertyOptions" autocomplete="off" [attr.aria-describedby]="selectedAction + '-property-error-' + index" />
          <mat-autocomplete #propertyOptions="matAutocomplete">
            @for (property of suggestions(row.controls.propertyName.value); track property.name) {
              <mat-option [value]="property.name">{{ property.label }} ({{ property.name }})</mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Value</mat-label>
          @if (property(row.controls.propertyName.value)?.type === 'enumeration') {
            <mat-select formControlName="value">
              @for (option of property(row.controls.propertyName.value)?.options || []; track option.value) {
                @if (!option.hidden) {<mat-option [value]="option.value">{{ option.label }} ({{ option.value }})</mat-option>}
              }
            </mat-select>
          } @else if (property(row.controls.propertyName.value)?.type === 'bool') {
            <mat-select formControlName="value"><mat-option value="true">true</mat-option><mat-option value="false">false</mat-option></mat-select>
          } @else {
            <input matInput formControlName="value" maxlength="4000" autocomplete="off" [attr.aria-describedby]="selectedAction + '-property-error-' + index" />
          }
        </mat-form-field>
        <button mat-icon-button type="button" class="remove-property" (click)="remove(index)" [disabled]="disabled" [attr.aria-label]="'Remove ' + (row.controls.propertyName.value || 'property')"><mat-icon>delete_outline</mat-icon></button>
        @if (rowError(selectedAction, index); as error) {<p class="property-error" role="alert" [id]="selectedAction + '-property-error-' + index">{{ error }}</p>}
      </div>
    } @empty {<p class="help-text">No additional properties for this action.</p>}
  </div>
  <button mat-stroked-button type="button" (click)="add()" [disabled]="disabled || !context || !!loading[objectType()] || !!errors[objectType()] || rows().length >= 50"><mat-icon>add</mat-icon>Add property</button>
  <p class="help-text">Save settings to apply values to future calls, including pending deliveries. Saving does not start a sync. Removing a row does not clear values in HubSpot.</p>
</section>
